import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import {
  BuyDiscountCodeResponse,
  GetDiscountCodesResponse,
  GetSearchedUnilevelUsersResponse
} from './DiscountCode.types';

export const getDiscountCodesAsync = async (): Promise<
  ApiResponseType<GetDiscountCodesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetDiscountCodesResponse>>(
    `/discounts/trading`
  );

  return data;
};

export const getSearchedUnilevelUsersAsync = async ({
  searchTerm
}: {
  searchTerm: any;
}): Promise<ApiResponseType<GetSearchedUnilevelUsersResponse>> => {
  let query = '';
  if (isNaN(searchTerm)) {
    query = `?username=${searchTerm}`;
  } else {
    query = `?userId=${searchTerm}`;
  }

  const { data } = await axios.get<
    ApiResponseType<GetSearchedUnilevelUsersResponse>
  >(`/user/team/unilevel/search${query}`);

  return data;
};

export const buyDiscountCodeAsync = async ({
  discountCodeId,
  receiverUserId
}: {
  discountCodeId: number;
  receiverUserId: number;
}): Promise<ApiResponseType<BuyDiscountCodeResponse>> => {
  const { data } = await axios.post<ApiResponseType<BuyDiscountCodeResponse>>(
    '/discounts',
    { discountCodeId, receiverUserId }
  );

  return data;
};
